import { formatMoney } from '@transferwise/formatting';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import ProviderLogo from '../../common/ProviderLogo';

import componentStyles from './ComparisonTableVersus.module.less';

const ComparisonTableVersus = ({
  styles,
  sourceCurrency,
  chosenProviderAlias,
  quotes,
  headerComponent,
}) => {
  const derivedStyles = { ...componentStyles, ...styles };
  const sortedQuotes = quotes.sort((a, b) => a.sendAmount - b.sendAmount);
  const { locale } = useIntl();
  return (
    <div className={derivedStyles['comparison-versus']}>
      {headerComponent && (
        <div className={derivedStyles['comparison-versus__header']}>{headerComponent}</div>
      )}

      <table className={derivedStyles['table-versus']}>
        <tbody>
          {sortedQuotes.map((quote) => (
            <tr
              className={derivedStyles[quote.alias === chosenProviderAlias ? 'featured-row' : '']}
              key={quote.alias}
            >
              <td className={derivedStyles['table-versus__cell']}>
                <ProviderLogo
                  styles={{
                    providerLogo: derivedStyles['table-versus__provider_logo'],
                  }}
                  logo={quote.logo}
                  altText={quote.logoAltText ? quote.logoAltText : quote.name}
                  name={quote.name}
                  alias={quote.alias}
                />
              </td>
              <td className={derivedStyles['table-versus__cell']}>
                <span className={derivedStyles['send-amount']}>
                  {formatMoney(quote.sendAmount, sourceCurrency, locale, {
                    alwaysShowDecimals: true,
                  })}
                </span>
                <span className={derivedStyles['supporting-text']}>
                  {quote.alias === chosenProviderAlias ? (
                    <FormattedMessage id="you-sent" />
                  ) : (
                    <FormattedMessage id="possible-cost" />
                  )}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

ComparisonTableVersus.propTypes = {
  // TODO Not sure if this should be derived from 'quote'
  sourceCurrency: PropTypes.string.isRequired,

  // This could be derived from cheapest etc, but actually the copy is in context of this provider too
  chosenProviderAlias: PropTypes.string.isRequired,

  quotes: PropTypes.arrayOf(
    PropTypes.shape({
      alias: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      logo: PropTypes.string.isRequired,
      logoAltText: PropTypes.string.isRequired,
      sendAmount: PropTypes.number.isRequired,
    }),
  ).isRequired,

  styles: PropTypes.shape({
    'table-versus': PropTypes.string,
    'table-versus__cell': PropTypes.string,
    'featured-row': PropTypes.string,
    'supporting-text': PropTypes.string,
  }),

  headerComponent: PropTypes.element,
};

ComparisonTableVersus.defaultProps = {
  styles: {},
  headerComponent: null,
};

export default ComparisonTableVersus;
